
<aside class="basketDock" :style="{'--basketDockBottom': `${bottom}px`}" :aria-label="$t('BASKET')">
  <v-icon class="basketIcon" size="28" aria-hidden="true">shopping_cart</v-icon>
  <div class="basketSummary" aria-live="polite" aria-atomic="true">
    <div class="itemCount">{{ $t('BASKET_ITEM_COUNT').replace('{amount}', basket.positionCount) }}</div>
    <div class="subtotal">
      <span>{{ $t('BASKET_SUBTOTAL') }}:</span>
      <strong>{{ formatPrice(basket.subtotal) }}</strong>
    </div>
  </div>
  <v-btn color="primary" to="/basket" class="basketButton">{{ $t('GO_TO_BASKET') }}</v-btn>
</aside>
